import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Loto7() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="lt7" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="lt7" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="lt7" />
    </>
  );
}
export default Loto7;
